import script from "./message-concurrency-limit.vue?vue&type=script&lang=ts&setup=true"
export * from "./message-concurrency-limit.vue?vue&type=script&lang=ts&setup=true"

import "./message-concurrency-limit.vue?vue&type=style&index=0&id=1ce36c85&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ce36c85"]])

export default __exports__